const ChannelExceptionAddStatistics = () =>
  import('@/views/main/wechatMgmt/channelExceptionAddStatistics/ChannelExceptionAddStatistics.vue')
export default {
  path: '/main/wechatMgmt/channelExceptionAddStatistics',
  name: 'ChannelExceptionAddStatistics',
  component: ChannelExceptionAddStatistics
}
